import type { App } from 'vue';
import { numberInputDirective } from './numberInput';

export const initDirectives = (app: App) => {
    app.directive('number-input', numberInputDirective)
}
